import { Trans } from '@lingui/macro'
import { ReactNode } from 'react'

import { ShopperBoxesCount } from './ShopperBoxesCount'
import { VouchersCount } from './VouchersCount'
import { useHasPrivilegesMenuItem } from '../../account/dashboard/useHasVouchersMenu'
import { PERSONAL_SHOPPER_ENABLED } from '../../constants'
import paths from '../../paths'
import AccountOrdersIcon from '../icons/AccountOrdersIcon'
import AccountOverViewIcon from '../icons/AccountOverviewIcon'
import AccountPrivilegesIcon from '../icons/AccountPrivilegesIcon'
import AccountSettingsIcon from '../icons/AccountSettingsIcon'
import AccountShopperIcon from '../icons/AccountShopperIcon'
import AccountWishlistIcon from '../icons/AccountWishlistIcon'

type MenuItem = {
    name: string
    icon: ReactNode
    href: string
    label: string | ReactNode
    badge?: ReactNode
    exact?: boolean
}

export const useMenuItems = (): MenuItem[] => {
    const hasPrivilegesMenu = useHasPrivilegesMenuItem()

    const defaultMenuItems: MenuItem[] = [
        {
            name: 'Dashboard',
            icon: <AccountOverViewIcon />,
            label: <Trans id="account.menu.overview">Overview</Trans>,
            href: paths.account,
            exact: true,
        },
        {
            name: 'Orders',
            icon: <AccountOrdersIcon />,
            label: <Trans id="account.menu.orders">Orders</Trans>,
            href: paths.orderOverview,
            exact: false,
        },

        {
            name: 'Wishlist',
            icon: <AccountWishlistIcon />,
            label: <Trans id="account.menu.wishlist">Wishlist</Trans>,
            href: paths.accountWishlist,
            exact: true,
        },
        {
            name: 'Accountdetails',
            icon: <AccountSettingsIcon />,
            label: <Trans id="account.menu.info">Account info</Trans>,
            href: paths.accountInfo,
            exact: false,
        },
    ]

    if (hasPrivilegesMenu) {
        defaultMenuItems.splice(2, 0, {
            name: 'Loyalty',
            icon: <AccountPrivilegesIcon />,
            label: <Trans id="account.menu.privileges">Privileges</Trans>,
            href: paths.accountPrivileges,
            badge: <VouchersCount />,
            exact: false,
        })
    }

    if (PERSONAL_SHOPPER_ENABLED) {
        defaultMenuItems.splice(4, 0, {
            name: 'Personal shopper',
            icon: <AccountShopperIcon />,
            label: (
                <Trans id="user.menu.personalShopper">Personal shopper</Trans>
            ),
            href: paths.personalShopper,
            badge: <ShopperBoxesCount />,
            exact: true,
        })
    }

    return defaultMenuItems
}
